var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-container" }, [
    _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
    _c(
      "div",
      {
        staticClass: "query-row",
        class: [
          _vm.updateGuide && _vm.updateGuideStep === 1 ? "query-row-guide" : "",
        ],
      },
      [
        _c("span", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("confirmation_dashboard_query_entity")) + ":"),
        ]),
        _c(
          "el-select",
          {
            staticClass: "input-with-select",
            attrs: { clearable: "", multiple: "", "collapse-tags": "" },
            on: { change: _vm.changeCondition },
            model: {
              value: _vm.entityIds,
              callback: function ($$v) {
                _vm.entityIds = $$v
              },
              expression: "entityIds",
            },
          },
          _vm._l(_vm.entityOpt, function (item) {
            return _c("el-option", {
              key: item.id,
              attrs: { label: item.entityName, value: item.id },
            })
          }),
          1
        ),
        _c("span", { staticClass: "label mgl20" }, [
          _vm._v(_vm._s(_vm.$t("confirmation_dashboard_query_type")) + ":"),
        ]),
        _c(
          "el-select",
          {
            staticClass: "input-with-select",
            attrs: { clearable: "", multiple: "", "collapse-tags": "" },
            on: { change: _vm.changeCondition },
            model: {
              value: _vm.confirmationType,
              callback: function ($$v) {
                _vm.confirmationType = $$v
              },
              expression: "confirmationType",
            },
          },
          _vm._l(_vm.confirmationTypeOpt, function (item) {
            return _c("el-option", {
              key: item.value,
              attrs: {
                label:
                  _vm.$i18n.locale === "en" ? item.label_en : item.label_zh,
                value: item.value,
              },
            })
          }),
          1
        ),
        _vm.updateGuide && _vm.updateGuideStep === 1
          ? _c("div", { staticClass: "updateGuideTitle" }, [
              _c(
                "div",
                { staticClass: "updateGuideTip" },
                [
                  _c("div", { staticClass: "margin-bottom-10" }, [
                    _vm._v(_vm._s(_vm.updateGuideStep) + "/2"),
                  ]),
                  _c("div", { staticClass: "margin-bottom-10" }, [
                    _vm._v(
                      _vm._s(_vm.$t(`dashboard_bubble_${_vm.updateGuideStep}`))
                    ),
                  ]),
                  _c(
                    "el-button",
                    { staticClass: "guide-btn", on: { click: _vm.nextClick } },
                    [_vm._v(_vm._s(_vm.$t("next")))]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c("div", { staticClass: "echarts" }, [
      _c("div", { staticClass: "echarts-item mgr15" }, [
        _c("div", { staticClass: "echarts-title" }, [
          _c("img", {
            staticClass: "title-icon",
            attrs: { src: require("@/assets/img/icon-overview.svg") },
          }),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("confirmation_dashboard_chart1_title"))),
          ]),
        ]),
        _c("div", { staticClass: "echarts-context" }, [
          _c("div", { staticClass: "total" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("total")))]),
            _c("div", { staticClass: "num" }, [_vm._v(_vm._s(_vm.pieTotal))]),
          ]),
          _c(
            "div",
            { staticClass: "pie-echarts" },
            [
              _c("echarts-pie", {
                attrs: { id: "confirmation-pie", pieData: _vm.pieData },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "echarts-item mgr15" }, [
        _c("div", { staticClass: "echarts-title" }, [
          _c("img", {
            staticClass: "title-icon",
            attrs: { src: require("@/assets/img/icon-confirmations-type.svg") },
          }),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("confirmation_dashboard_chart2_title"))),
          ]),
        ]),
        _c("div", { staticClass: "echarts-context" }, [
          _c(
            "div",
            { staticClass: "bar-echarts" },
            [
              _c("echarts-bar", {
                attrs: {
                  id: "confirmation-bar1",
                  renderData: _vm.barData1,
                  "chart-style": _vm.chartStyle1,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      !_vm.showConfirmationReplyStatus
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticClass: "echarts-item",
            },
            [
              _c("div", { staticClass: "echarts-title" }, [
                _c("img", {
                  staticClass: "title-icon",
                  attrs: {
                    src: require("@/assets/img/icon-long-outstanding.svg"),
                  },
                }),
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("confirmation_dashboard_chart3_title"))),
                ]),
              ]),
              _c("div", { staticClass: "echarts-context" }, [
                _c("div", { staticClass: "echarts-header" }, [
                  _c(
                    "div",
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("confirmation_dashboard_chart3_title_part1")
                          ) +
                          "\n                        "
                      ),
                      _c("el-input", {
                        staticClass: "filter-input",
                        attrs: { onkeyup: "value=value.replace(/[^\\d]/g,'')" },
                        on: { change: _vm.changeCondition2 },
                        model: {
                          value: _vm.filterDay,
                          callback: function ($$v) {
                            _vm.filterDay = $$v
                          },
                          expression: "filterDay",
                        },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("confirmation_dashboard_chart3_title_part2")
                          ) +
                          "\n                    "
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "total" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("total")))]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.barTotal2)),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "bar-echarts2" },
                  [
                    _c("echarts-bar", {
                      attrs: {
                        id: "confirmation-bar2",
                        renderData: _vm.barData2,
                        "chart-style": _vm.chartStyle2,
                        filterDay: _vm.filterDay,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _c("div", { staticClass: "echarts-item" }, [
            _c("div", { staticClass: "echarts-title" }, [
              _c("img", {
                staticClass: "title-icon",
                attrs: {
                  src: require("@/assets/img/icon-long-outstanding.svg"),
                },
              }),
              _c("div", [
                _vm._v(_vm._s(_vm.$t("confirmation_replyRate_analysis"))),
              ]),
            ]),
            _c("div", { staticClass: "echarts-context" }, [
              _c("div", { staticClass: "echarts-comment" }, [
                _vm._v(
                  _vm._s(_vm.$t("confirmation_replyRate_analysis_comment"))
                ),
              ]),
              _c("div", { staticClass: "echarts-header" }, [
                _c("div", { staticClass: "total" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("total")))]),
                  _c("div", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.barTotal4) + "%"),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "bar-echarts2" },
                [
                  _c("echarts-bar", {
                    attrs: {
                      id: "confirmation-bar3",
                      renderData: _vm.barData4,
                      "chart-style": _vm.chartStyle2,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
    ]),
    _vm.showConfirmationReplyStatus
      ? _c("div", { staticClass: "echarts-item4" }, [
          _c("div", { staticClass: "echarts-title" }, [
            _c("div", { staticClass: "left" }, [
              _c("img", {
                staticClass: "title-icon",
                attrs: { src: require("@/assets/img/icon-overview.svg") },
              }),
              _c("div", [_vm._v(_vm._s(_vm.$t("confirmation_echart4_title")))]),
              _c("div", { staticClass: "echarts-item4-guide" }, [
                _c("div", {
                  staticClass: "echarts-item4-subtitle",
                  domProps: { innerHTML: _vm._s(_vm.$t("echarts4_subtitle")) },
                }),
                _vm.updateGuide && _vm.updateGuideStep === 2
                  ? _c("div", { staticClass: "updateGuideTitle" }, [
                      _c(
                        "div",
                        { staticClass: "updateGuideTip" },
                        [
                          _c("div", { staticClass: "margin-bottom-10" }, [
                            _vm._v(_vm._s(_vm.updateGuideStep) + "/2"),
                          ]),
                          _c("div", { staticClass: "margin-bottom-10" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  `dashboard_bubble_${_vm.updateGuideStep}`
                                )
                              )
                            ),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "guide-btn",
                              on: { click: _vm.gotItClick },
                            },
                            [_vm._v(_vm._s(_vm.$t("gotIt")))]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green table-btn",
                    attrs: { loading: _vm.exportLoading },
                    on: { click: _vm.exportPendingAnalyse },
                  },
                  [_vm._v(_vm._s(_vm.$t("export_list")))]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "echarts-container" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "notice" }, [
                _c("span", { staticClass: "redstar" }, [_vm._v("*")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("you_can_input_day_count_will_auto_refresh"))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "input-container" }, [
                _c("div", { staticClass: "input-table" }, [
                  _c("div", { staticClass: "td-row td-row-0" }, [
                    _c("div", { staticClass: "td-left" }),
                    _c("div", { staticClass: "td-right" }, [
                      _vm._v(_vm._s(_vm.$t("please_input")) + "*"),
                    ]),
                  ]),
                  _c("div", { staticClass: "td-row td-row-1" }, [
                    _c("div", { staticClass: "td-left" }, [
                      _vm._v(_vm._s(_vm.$t("confirmation_bar4_inputtip_1"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "td-right" },
                      [
                        _c("el-input", {
                          staticClass: "td-right-input",
                          attrs: { placeholder: "5" },
                          on: { blur: _vm.getPendingAnalyse },
                          model: {
                            value: _vm.confirmation_bar4_input_1,
                            callback: function ($$v) {
                              _vm.confirmation_bar4_input_1 = $$v
                            },
                            expression: "confirmation_bar4_input_1",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "td-row td-row-2" }, [
                    _c("div", { staticClass: "td-left" }, [
                      _vm._v(_vm._s(_vm.$t("confirmation_bar4_inputtip_2"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "td-right" },
                      [
                        _c("el-input", {
                          staticClass: "td-right-input",
                          attrs: { placeholder: "15" },
                          on: { blur: _vm.getPendingAnalyse },
                          model: {
                            value: _vm.confirmation_bar4_input_2,
                            callback: function ($$v) {
                              _vm.confirmation_bar4_input_2 = $$v
                            },
                            expression: "confirmation_bar4_input_2",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.barData3Loading,
                    expression: "barData3Loading",
                  },
                ],
                staticClass: "right",
              },
              [
                _c("EchartsXBar", {
                  staticClass: "right1",
                  attrs: {
                    renderData: _vm.barData3,
                    confirmation_bar4_input_1: _vm.confirmation_bar4_input_1,
                    confirmation_bar4_input_2: _vm.confirmation_bar4_input_2,
                  },
                }),
                _c("div", { staticClass: "right2" }, [
                  _c("div", { staticClass: "right2-title" }, [
                    _vm._v(_vm._s(_vm.$t("confirmation_count"))),
                  ]),
                  _c("div", { staticClass: "right2-count-num-1" }, [
                    _vm._v(_vm._s(_vm.chart4ConfirmationCount[0])),
                  ]),
                  _c("div", { staticClass: "right2-count-num-2" }, [
                    _vm._v(_vm._s(_vm.chart4ConfirmationCount[1])),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c("div", { staticClass: "table-title" }, [
          _c("div", { staticClass: "left" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("confirmation_dashboard_table_title")) +
                "\n            "
            ),
          ]),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-green table-btn",
                  attrs: { loading: _vm.exportLoading2 },
                  on: { click: _vm.exportProgress },
                },
                [_vm._v(_vm._s(_vm.$t("export_list")))]
              ),
            ],
            1
          ),
        ]),
        _c("DashboardTable", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          attrs: {
            "table-data": _vm.tableData,
            "table-data-source": _vm.tableDataSource,
            showConfirmationReplyStatus: _vm.showConfirmationReplyStatus,
          },
        }),
        _vm.tablePager.total > 50
          ? _c("el-pagination", {
              staticClass: "wl-pagination",
              attrs: {
                "current-page": _vm.tablePager.pageNum,
                "page-size": _vm.tablePager.pageSize,
                "page-sizes": [50, 100, 200],
                layout: "prev, pager, next, sizes, total",
                total: _vm.tablePager.total,
              },
              on: {
                "size-change": _vm.onSizeChange,
                "current-change": _vm.onPageChange,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }